'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/account-panel.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _panelWhiteAside = require('@marmalade/panel/lib/panel-white-aside');
var _panelWhiteAside2 = _interopRequireDefault(_panelWhiteAside);
var _panelWhite = require('@marmalade/panel/lib/panel-white');
var _panelWhite2 = _interopRequireDefault(_panelWhite);
var _icon = require('@marmalade/icon');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var AccountPanel = function (_Component) {
  _inherits(AccountPanel, _Component);
  function AccountPanel() {
    _classCallCheck(this, AccountPanel);
    return _possibleConstructorReturn(this, (AccountPanel.__proto__ || Object.getPrototypeOf(AccountPanel)).apply(this, arguments));
  }
  _createClass(AccountPanel, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var marmalade = process.env.REACT_APP_THEME === 'marmalade';
      var Panel = marmalade ? _panelWhiteAside2.default : _panelWhite2.default;
      return _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          margin: props.theme.space_md + ' auto',
          maxWidth: marmalade ? 800 : 500
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        },
        __self: this
      }, _react2.default.createElement(Panel, {
        img: props.img,
        alt: props.alt,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        },
        __self: this
      }, _react2.default.createElement(_icon.MediumPrimaryIcon, {
        type: props.icon,
        css: {
          marginBottom: props.theme.space_sm
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.H2, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }, props.title)), props.children));
    }
  }]);
  return AccountPanel;
}(_react.Component);
AccountPanel.propTypes = {
  img: _propTypes.node.isRequired,
  alt: _propTypes.string.isRequired,
  icon: _propTypes.node.isRequired,
  title: _propTypes.string.isRequired,
  theme: _propTypes.object.isRequired
};
exports.default = (0, _glamorous.withTheme)(AccountPanel);